<template>
  <div class="page">
    <van-nav-bar title="实习周报" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <van-tabs type="line" v-model="active" animated color="#0088F8" @click="tabsChange">
      <van-tab title="写周报">
        <!-- <van-notice-bar color="#F85352" background="#fae6e5" left-icon="info-o" mode="closeable">只能提交最近{{ delayDay }}天的实习周报，提交时间限制在每周一{{ lastTime }}之前</van-notice-bar> -->
        <van-form @submit="onSubmit" style="height: calc(100vh - 90px)">
          <van-field v-model="form.bt" name="标题" label="标题" input-align="right" error-message-align="right" placeholder="请输入" :rules="[{ required: true, message: '请填写标题' }]" />
          <van-field v-model="form.sjfw" is-link readonly label="选择日期" input-align="right" error-message-align="right" placeholder="请选择" @click="showDatePicker" :rules="[{ required: true, message: '请选择日期' }]" />
          <van-field style="margin-top: 10px" class="textarea" v-model="form.nr" rows="5" autosize label="内容" type="textarea" placeholder="请输入内容" :rules="[{ required: true, message: '请输入日志内容' }]" />
          <van-field name="uploader" label="">
            <template #input>
              <van-uploader accept="image/*" :max-size="5 * 1024 * 1024" @oversize="$toast('文件大小不能超过 5M ')" :max-count="1" :after-read="upload" v-model="fileList" />
            </template>
          </van-field>
          <div class="map">
            <el-amap ref="map" class="amap-box" :vid="'amap-vue'" :amap-manager="amapManager" :plugin="plugin"></el-amap>
          </div>
          <div class="position" v-if="schoolCode !== '10848'">
            <div class="title">
              <div>您当前所在位置</div>
              <div style="color: #0189F9;" @click="rePosition">重新定位</div>
            </div>
            <div class="content">
              <van-loading v-if="form.dz == ''" type="spinner" size="14" />
              {{ form.dz || '定位获取中…' }}
            </div>
          </div>
          <div class="button-box">
            <van-button round type="info" native-type="submit">提交</van-button>
          </div>
        </van-form>
      </van-tab>
      <van-tab title="历史周报">
        <div class="total-box">
          <div class="title" @click="showPicker = true">
            <div class="left">{{ month }}月汇总</div>
            <!-- <img src="../../static/right-arrow.png" /> -->
            <van-icon name="arrow" />
          </div>
          <div class="content">
            <div class="item-box" v-for="(item, index) in pageData.totalList" :key="'total' + index">
              <div class="top">{{ item.value }}</div>
              <div class="bottom">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <!-- 周历 -->
        <div class="calendar">
          <div class="title">
            每月记录
            <p>({{ month }}月)</p>
          </div>
          <div style="padding: 0 15px">
            <CalendarWeek ref="ren" :year="year" :month="pageMonth" :list="pageData.weekList" :startDay="startTime" :endDay="endTime" @dateClick="dateClick"></CalendarWeek>
          </div>

          <div v-if="!weekObj.hasData" class="empty-sign">
            <img src="../../../../assets/images/no_sign.png" alt="" />
            <div>未提交周报</div>
          </div>
          <!-- 当日评阅记录 -->
          <div class="comment" v-else>
            <div class="status">
              指导教师评阅：
              <p :style="{ color: getCommentStatusColor }">{{ getCommentStatus }}</p>
            </div>
            <div class="comment-content" v-if="weekObj.status == '2' || weekObj.status == '3'">
              <div class="comment-title">评语</div>
              <div>{{ weekObj.comment }}</div>
            </div>
          </div>
        </div>
        <!-- 日志详细 -->
        <div class="daily-content" v-if="weekObj.hasData" :style="{ paddingBottom: getCanEditStatus ? '0' : '15px' }">
          <div class="title">标题</div>
          <div class="content">
            {{ weekDetail.bt }}
          </div>
          <div class="title">内容</div>
          <div class="content">
            {{ weekDetail.nr }}
          </div>
          <div class="title">图片</div>
          <div class="content">
            <img :src="weekDetail.base64" alt="" />
          </div>
          <div class="title">位置</div>
          <div class="content">
            {{ weekDetail.dz }}
          </div>
          <div class="edit-button" v-if="getCanEditStatus" @click="editData">
            <van-icon name="edit" />
            <div>修改周报</div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <!-- 选择月历月份 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker v-model="currentDate" type="year-month" title="选择年月" :min-date="minDate" :max-date="maxDate" @cancel="showPicker = false" :formatter="formatter" @confirm="chooseMonth" />
    </van-popup>
    <!-- 选择实习日志日期 -->
    <van-popup v-model="showPickerDate" position="bottom">
      <van-picker title="选择周报日期" show-toolbar @cancel="showPickerDate = false" :columns="weeks" @confirm="chooseDate" :default-index="defaultIndex" />
    </van-popup>
  </div>
</template>

<script>
import  iApi  from '@/utils/internship'
import CalendarWeek from './components/calendarWeek'
import { AMapManager } from 'vue-amap'
import { mapGetters } from 'vuex'
let amapManager = new AMapManager()
export default {
  components: {
    CalendarWeek,
  },
  data() {
    let self = this
    return {
      schoolCode:sessionStorage.getItem("schoolCode"),
      isEdit: false,
      amapManager,
      plugin: [
        {
          pName: 'Geolocation',
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：5s
          buttonPosition: 'RB', //定位按钮的停靠位置
          zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                if (status == 'complete') {
                  self.complete(result)
                } else {
                  self.$toast.fail('定位失败！')
                }
              })
            },
          },
        },
      ],
      active: 0,
      fileList: [],
      showEmpty: false,
      pageData: {
        totalList: [],
        weekList: [],
      },
      form: {
        sxjhid: '',
        dz: '',
        nr: '',
        bt: '',
        sjfw: '',
        sxzbid: '', // 只在编辑的时候传
        file: '',
      },
      showPicker: false,
      showPickerDate: false,
      currentDate: new Date(),
      nowDate: new Date(),
      date: new Date().format('yyyy-MM'),
      weekObj: {},
      month: new Date().getMonth() + 1,
      delayDay: 0,
      weekDetail: {
        base64: '',
        bt: '',
        dz: '',
        filepath: '',
        nr: '',
      },
      lastTime: '23:29',
      year: new Date().getFullYear().toString(),
      pageMonth: new Date().getMonth().toString(),
      weeks: [],
      startDay:'',
      endDay:'',
      defaultIndex:0,
      starMonth:'',
      endMonth:'',
      minDate:null,
      maxDate:null,
      endTime:'',
      startTime:''
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid',
    }),
    getCommentStatus() {
      if(this.schoolCode == '14475'){
        if (this.weekObj.status == '1') {
          return '评阅中'
        } else if (this.weekObj.status == '2') {
          return this.weekObj.level
        } else if (this.weekObj.status == '3') {
          return '打回'
        }
      }else{
        if (this.weekObj.status == '1') {
          return '评阅中'
        } else if (this.weekObj.status == '2') {
          return this.weekObj.level
        }
      }
      
    },
    getCommentStatusColor() {
      if (this.weekObj.status == '1') {
        return '#999999'
      } else if (this.weekObj.status == '2') {
        return '#F85352'
      }
    },
    getCanEditStatus() {
      let dif = (new Date().getTime() - new Date(this.weekObj.date.split('~')[1]).getTime()) / 24 / 3600 / 1000
      if (dif < this.delayDay - 1 && (this.weekObj.status == '1' || this.weekObj.status == '3')) {
        // 在可编辑的时间范围内，并且状态还是未评阅
        return true
      }
      return false
    },
  },
  methods: {
    /**
     * @description: 地图定位完成
     * @param {Object} result 定位结果
     */
    complete(result) {
      this.form.dz = result.formattedAddress
    },

    /**
     * @description: 打开选择日志日期弹窗，只在新增模式下可以打开
     */
    showDatePicker() {
      if (!this.isEdit) {
        this.showPickerDate = true
      }
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      }
      return val
    },
    chooseMonth(e) {
      this.showPicker = false
      this.month = new Date(e).getMonth() + 1
      this.year = new Date(e).getFullYear().toString()
      this.pageMonth = new Date(e).getMonth().toString()
      this.date = new Date(e).format('yyyy-MM')
      // console.log(this.year, this.pageMonth)
      this.getWeeklyData()
    },

    /**
     * @description: 选择周报时间段日期
     * @param {Date} e 选择的日期
     */
    chooseDate(e) {
      this.showPickerDate = false
      this.form.sjfw = e
    },

    /**
     * @description: 重新定位事件，获取地图插件通过重新调用方法，获取地址
     */
    rePosition() {
      this.form.dz = ''
      this.$refs.map.$plugins['AMap.Geolocation'].getCurrentPosition((status, result) => {
        if (status == 'complete') {
          this.complete(result)
        } else {
          this.$toast.fail('定位失败！')
        }
      })
    },
    async dateClick(e) {
      console.log(e)
      let index = this.pageData.weekList.findIndex(week => week.date === e)
      if (index != -1) {
        this.weekObj = this.pageData.weekList[index]
        if (this.pageData.weekList[index].id != '') {
          this.getWeeklyDetail(this.pageData.weekList[index].id)
        }
      }
    },
    /**
     * @description: tab监听，当tabs为1的时候请求日历接口
     * @param {*} e
     * @return {*}
     */
    tabsChange(e) {
      if (e == 1) {
        this.getWeeklyData()
        // 默认选中当周
      }
    },

    /**
     * @description: 文件上传，通过上传组件，直接将file赋值
     * @param {*} e
     * @return {*}
     */
    upload(e) {
      this.form.file = e.file
    },

    /**
     * @description: 修改周报
     * @param {*}
     * @return {*}
     */
    editData() {
      this.isEdit = true
      this.form = {
        sxjhid: this.sxjhid,
        dz: '',
        nr: this.weekDetail.nr,
        bt: this.weekDetail.bt,
        sjfw: this.weekDetail.sjfw,
        sxzbid: this.weekObj.id, // 只在编辑的时候传
        file: '',
      }
      this.fileList.push({
        content: this.weekDetail.base64,
      })
      this.active = 0
      this.rePosition()
    },

    /**
     * @description: 表单提交
     * @param {*}
     * @return {*}
     */
    async onSubmit() {
      if(this.form.nr.indexOf("'") != -1){
        this.$toast('输入内容存在非法字符，请检查后重新提交!')
        return false;
      }
      this.form.sxjhid = this.sxjhid
      const res = await iApi.postWeeklyData(this.form)
      if (res.code == '1') {
        this.$toast('提交实习日志成功')
        this.form = {
          sxjhid: '',
          dz: '',
          nr: '',
          bt: '',
          sjfw: '',
          sxzbid: '', // 只在编辑的时候传
          file: '',
        }
        this.active = 1
        this.getWeeklyData()
        // 编辑后返回原页面
        this.isEdit = false
        this.fileList = []
        if (this.weekObj != {}) {
          this.getWeeklyDetail(this.weekObj.id)
        }
      } else {
        this.$toast(res.msg)
      }
    },
    async getWeeklyData() {
      const res = await iApi.getWeeklyList({
        sxjhid: this.sxjhid,
        ny: this.date,
      })
      this.pageData = res.data
      let now = new Date()
      let dayTime = 24 * 3600 * 1000
      let nowWeek = new Date(now.getTime() - (now.getDay() - 1) * dayTime).format('yyyy-MM-dd') + '~' + new Date(now.getTime() + (7 - now.getDay()) * dayTime).format('yyyy-MM-dd')
      let index = this.pageData.weekList.findIndex(item => item.date == nowWeek)
      if (index != -1) {
        this.weekObj = this.pageData.weekList[index]
        this.$refs.ren.clickDate(index)
        this.getWeeklyDetail(this.weekObj.id)
      }
    },
    async getWeeklyDetail(id) {
      if (id != '') {
        const res = await iApi.getWeeklyDetail({
          sxzbid: id,
        })
        this.weekDetail = res.data
      }
    },

    /**
     * @description: 根据延迟时间判断用户可选的周区间
     * @param {*}
     * @return {*}
     */
     getWeeks() {
      let today = new Date() // 今天
      let dayTime = 24 * 3600 * 1000
      let weekTime = 7 * 24 * 3600 * 1000
      let day = today.getDay() == 0?7:today.getDay()
      // 获取本周
      //let start =  new Date(today.getTime() - (day - 1) * dayTime).format('yyyy-MM-dd')
      //let end = new Date(today.getTime() + ( 7 - day) * dayTime).format('yyyy-MM-dd')
      //this.weeks.push(`${start}~${end}`)
      // 看延迟时间是否大于今天到周一的时间
      //let num = 0
      //if(this.delayDay > day - 1){
        //num = Math.ceil((this.delayDay - day) / 7) + 1
      //} else if(day == 1){
        //num = 1
      //}
      //for (let i = 1; i < num; i++) {
       // let mon = new Date(new Date(start).getTime() - i * weekTime)
       // let sun = new Date(new Date(end).getTime() - i* weekTime)
        //this.weeks.push(mon.format('yyyy-MM-dd') + '~' + sun.format('yyyy-MM-dd'))
      //}
      // // 默认选择当周
      if(this.startDay!=''&&this.endDay!=''){
        let i=0;
        let startWeekend = new Date(this.startDay);
        let endWeekend = new Date(new Date(startWeekend).getTime()+6*dayTime);
        //this.weeks.push(startWeekend.format('yyyy-MM-dd') + '~' + endWeekend.format('yyyy-MM-dd'))
        while(true){
          if(endWeekend.getTime()>new Date(this.endDay).getTime()){
            break;
          }
          this.weeks.push(startWeekend.format('yyyy-MM-dd') + '~' + endWeekend.format('yyyy-MM-dd'))
          startWeekend = new Date(startWeekend.getTime()+7*dayTime)
          endWeekend = new Date(endWeekend.getTime()+7*dayTime)
        }
      }
      if(this.weeks.length>0){
        this.form.sjfw = this.weeks[this.weeks.length-1];
        this.defaultIndex = this.weeks.length-1;
      }
      
    },
  },

  async created() {
    const res = await iApi.getWeeklyTime({ sxjhid: this.sxjhid })
    this.delayDay = parseInt(res.data.delayDay)
    this.lastTime = res.data.endingTime
    this.startDay = res.data.startDay
    this.endDay = res.data.endDay
    this.starMonth = res.data.starMonth
    this.endMonth = res.data.endMonth
    this.month = this.endMonth;
    this.maxDate = new Date(res.data.maxDate);
    this.minDate = new Date(res.data.minDate)
    this.endTime = res.data.endTime
    this.startTime = res.data.startTime
    this.getWeeks()
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
}
.empty {
  // margin-top: 167px;
  height: calc(100vh - 86px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #666666;
  text-align: center;
  img {
    width: 159px;
    height: 154px;
    margin-bottom: 30px;
  }
  .button {
    width: 232px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px;
    text-align: center;
    line-height: 50px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    margin-top: 50px;
  }
}
.item-box {
  width: 315px;
  min-height: 50px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto 0;
  padding: 12px 15px;
  .title-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      // width: 280px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .status {
      margin-left: 10px;
      min-width: 46px;
      height: 20px;
      border: 1px solid #41b29c;
      border-radius: 10px;
      text-align: center;
      line-height: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #41b29c;
    }
  }
  .date {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 5px 0;
  }
  .tip-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    p {
      color: #0088f8;
    }
  }
}
.button-box {
  width: 375px;
  height: 70px;
  background: #ffffff;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .van-button {
    width: 345px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px !important;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
  }
}
.map {
  overflow: hidden;
  width: 0px;
  height: 0px;
}
.position {
  margin-top: 10px;
  width: 345px;
  background: #ffffff;
  padding: 15px;
  .title {
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
  }
  .content {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #b2b2b2;
    margin-top: 5px;
    display: flex;
    align-items: center;
    .van-loading {
      position: relative;
      left: 0;
      margin-right: 10px;
    }
  }
}
.textarea {
  flex-direction: column;
  height: 200px;
  overflow-y:auto;
}
.total-box {
  width: 345px;
  height: 132px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto;
  .title {
    display: flex;
    justify-content: space-between;
    padding: 16px 20px 0 20px;
    .left {
      font-weight: bold;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      line-height: 22px;
      color: #333333;
    }
  }
  .content {
    display: flex;
    .item-box {
      width: 33.33%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .top {
        font-weight: bold;
        font-family: PingFangSC-Semibold;
        font-size: 26px;
        line-height: 37px;
        color: #333333;
      }
      .bottom {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        line-height: 20px;
        color: #666666;
      }
    }
  }
}
.calendar {
  width: 345px;
  // height: 566px;
  // padding-bottom: 25px;
  background: #ffffff;
  border-radius: 8px;
  margin: 0 auto;
  .title {
    padding-top: 18px;
    margin-left: 18px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    p {
      font-size: 14px;
      color: #999999;
    }
  }
  .empty-sign {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 15px;
    img {
      width: 76px;
      height: 76px;
      margin-bottom: 24px;
    }
    div {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      text-align: center;
      line-height: 18px;
    }
  }
  .comment {
    padding: 15px;
    .status {
      display: flex;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      p {
        color: #f85352;
      }
    }
    .comment-content {
      margin-top: 15px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      .comment-title {
        color: #999999;
        margin-bottom: 5px;
      }
    }
  }
}
.daily-content {
  width: 315px;
  background: #ffffff;
  border-radius: 8px;
  padding: 15px;
  margin: 10px auto;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  .title {
    color: #999999;
    margin-bottom: 5px;
  }
  .content {
    margin-bottom: 10px;
    img {
      width: 70px;
      height: 70px;
      border-radius: 4px;
      display: block;
      overflow: hidden;
    }
  }
  .edit-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    border-top: 1px solid #e5e5e5;
    i {
      margin-right: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/weekly.vue